import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getTransporteurs = async () => {
    const transporteurs = await axios.get('/service/transporteurs')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching transporteurs')
    })
    return transporteurs.data
}

export const getOptionsTransporteur = async () => {
    const optionsTransporteur = await axios.get('/service/transporteur/options')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching options transporteur')
    })
    return optionsTransporteur.data
}

export const postTransporteur = async transporteur => {
    const transporteurRemote = await axios.post('/service/transporteur', transporteur)
    .catch((e) => {
        throw new CustomException(e, 'Error posting transporteur')
    })
    return transporteurRemote.data
}

export const deleteTransporteur = async id => {
    const transporteur = await axios.delete(`/service/transporteur/${id}`)
    .catch((e) => {
        throw new CustomException(e, 'Error deleting transporteur')
    })
    Vue.toasted.show('Transporteur supprimé').goAway(1500)
    return transporteur.data
}

export const moveTransporteur = async params => {
    const transporteurRemote = await axios.post(`/service/transporteur/move/${params.position}`, params)
    .catch((e) => {
        throw new CustomException(e, 'Error moving transporteur')
    })
    return transporteurRemote.data
}